<template>
    <div>
        <div class="col">
              <div v-if="loadingRelated" class="d-flex justify-content-center mb-3">
    <b-spinner label="Loading..."></b-spinner>
  </div>
  
             <b-table
      :items="userSaleList"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      stacked="md"
      show-empty
      striped 
      fixed
      @filtered="onFiltered"
      v-else
    >
  
     
      <template #cell(name)="row">
          <div class="row">
              <div class="col">
                  
                  <img
                    :src= "imageOfHome(row.item.home)"
                    alt="content-img"
                    class="card-img-top"
                    width="10%"
                    id="show-btn" @click="$bvModal.show('bv-modal-example')"
                    
                  />
              </div>
              <div class="col">
                  
          <p>{{row.item.home.name}}</p>
              </div>
          </div>
     
      </template>
       <template #cell(place)="row">
          <h5 class="text-danger">{{row.item.home.adress}} , {{row.item.home.town}}</h5>
        
      </template>
      <template #cell(etat)="row">
          <h5 v-if="row.item.post_status===1">Publié</h5>
          <h5 v-else>Non publié</h5>
        
      </template>

      <template #cell(actions)="row">
          <div class="col">
             <p class="h3 mb-2"> 
         <vs-dropdown
            class="cursor-pointer logement"
          > 
           <div class="con-img ml-4"><b-icon icon="three-dots" aria-hidden="true" variant="dark" ></b-icon> </div>
             <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
            <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
          >
            <span class="ml-2">Modifier</span>
          </li>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push(`/home/rent/item/${row.item._id}`).catch(() => {})"
          >
            <span class="ml-2">Aperçu</span>
          </li>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
          >
            <span class="ml-2">Désactiver</span>
          </li>
           <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
          >
            <span class="ml-2">Dupliquer</span>
          </li>
 
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
       
        </p>
          </div>    
         
      </template>

      <template #row-details="row">
        <b-card>
          <ul>
           <h3> <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li></h3>
          </ul>
        </b-card>
      </template>
    </b-table>
        </div>
      <div class="pop-up">
          <b-modal id="bv-modal-example" hide-footer>
    <template #modal-title>
      Using <code>$bvModal</code> Methods
    </template>
    <div class="d-block text-center">
       <div  >
      <br>
      <br>
      <h3>Egayez vos annonces avec des images</h3>
          <b-form-file
      v-model="files"
      :state="Boolean(files)"
      multiple
      required
      placeholder="Choissisez vos images"
      drop-placeholder="Drop file here..."
    ></b-form-file>
    <br>
    <br>
    <br>
    <vs-button @click="upload()">Envoyer</vs-button>
    </div>
    </div>
  </b-modal>
    </div>
  
    </div>
</template>

<script>
import axios from '@/helpers/axios'
export default {
  data () {
    return {
      files :null,
      userSaleList :[],
      loadingRelated : true,
      fields: [
        { key: 'name', label: 'Annonce', sortable: true, sortDirection: 'desc' },
        { key: 'place', label: 'Adresse' },
        { key: 'etat', label: 'Etat', sortable: true, class: 'text-center' },
        { key: 'bedroom', label: 'Chambres' },
        { key: 'bathroom', label: 'Salles de bains' },
        { key: 'price', label: 'Prix' },
        { key: 'actions', label: 'Actions' }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, { value: 100, text: 'Show a lot' }],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      }
    }
  },
  computed: {

    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  methods :{
    imageOfHome (item) {
      
      if (item.pic.length > 0) {
        return `data:image/jpg;base64,${ item.home.pic[0].img.data}`
      }
      return 'https://i.pinimg.com/originals/2b/36/2f/2b362f7ea3e8b33f64260f01dd739a48.png'
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    fetch_user_hostingLists () {
      axios.get(`/user/getUserByHisMail/${this.$store.state.AppActiveUser.email}`
      ).then((response) => {    
        axios.get(`/home/sale/user/${response.data}`).then((response) => {
          if (response.data) {
            this.userSaleList = response.data
          }
          this.loadingRelated = false
        }).catch(() => {
          this.userSaleList = []
          this.loadingRelated = false
        })

      })
    } 
  },
  mounted () {
    this.fetch_user_hostingLists()

  }
}
</script>